// Main Scripts
// ---------------------
import controllerThemes from './js/controllerThemes.js';

import './js/localjs.js';

if (window.location.pathname === '/') {
  parent.location.href = 'p/saffire-concepts/';
}

$(document).ready(function () {
  controllerThemes();
});
